
import { User } from "lucide-react";
import { Profile } from "@/types/database.types";
import { useToast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";

interface UserTypeSelectorProps {
  user: Profile;
  isProtectedEmail: boolean;
  onUserTypeChange: () => void;
}

export const UserTypeSelector = ({ 
  user, 
  isProtectedEmail,
  onUserTypeChange 
}: UserTypeSelectorProps) => {
  const { toast } = useToast();

  // Determine user type display
  const getUserTypeDisplay = () => {
    if (isProtectedEmail) {
      return 'Super Admin';
    }
    
    switch (user.user_type) {
      case 'admin':
        return 'Admin';
      case 'peo':
        return 'PEO Provider';
      case 'broker':
        return 'Broker';
      case 'regular':
      default:
        return 'Regular User';
    }
  };

  // Demo mode notification
  const notifyDemoMode = () => {
    if (isProtectedEmail) {
      toast({
        title: "Protected Account",
        description: "The super admin account type cannot be modified.",
      });
    } else {
      toast({
        title: "User Type Information",
        description: "This displays the user's role in the system.",
      });
    }
  };

  return (
    <div className="flex justify-between items-center">
      <span className="text-sm text-muted-foreground">User Status</span>
      <Button 
        variant="outline" 
        size="sm"
        disabled={true}
        className="capitalize"
        onClick={notifyDemoMode}
      >
        <User className="mr-2 h-4 w-4" />
        {getUserTypeDisplay()}
      </Button>
    </div>
  );
};
